(() => {
  if (window.__cornerCartInfiniteOptionsBridge) return;
  window.__cornerCartInfiniteOptionsBridge = true;

  const selectors = {
    bundleOption: '[data-section-type="product"] select[name*="properties"]',
    cornerButton: '#corner-sticky-atc-cta-button',
    cornerQuantity: '#corner-sticy_atc-quantity-value',
    productForm: 'form.product-form[action*="/cart/add"]',
    productButton: '[data-add-to-cart]',
    productQuantity: 'input[name="quantity"]',
  };

  function getBundleProductForm() {
    const bundleOption = document.querySelector(selectors.bundleOption);
    if (!bundleOption) return null;

    const productSection = bundleOption.closest('[data-section-type="product"]');

    return (
      bundleOption.closest(selectors.productForm) ||
      productSection?.querySelector(selectors.productForm) ||
      null
    );
  }

  function syncQuantity(productForm) {
    const cornerQuantity = document.querySelector(selectors.cornerQuantity);
    const productQuantity = productForm.querySelector(selectors.productQuantity);
    if (!cornerQuantity || !productQuantity) return;

    const quantity = Math.max(1, Number.parseInt(cornerQuantity.value, 10) || 1);
    productQuantity.value = String(quantity);
    productQuantity.dispatchEvent(new Event('input', { bubbles: true }));
    productQuantity.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener(
    'click',
    (event) => {
      const cornerButton = event.target.closest?.(selectors.cornerButton);
      if (!cornerButton) return;

      // Infinite Options stores the customer's choices as line item
      // properties in the main product form. Corner Cart's own request only
      // sends the variant and quantity, so it must not handle this click.
      const productForm = getBundleProductForm();
      if (!productForm) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      syncQuantity(productForm);

      const productButton = productForm.querySelector(selectors.productButton);
      if (!productButton || productButton.disabled) {
        productForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      // Use the same click path as the product-page button so Simple Bundles
      // can validate and append all selected properties before the cart add.
      productButton.click();
    },
    true
  );
})();
